var React = require('react');

function UnloggedIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"d":"M0 2.813C0 1.778.84.937 1.875.937h11.25C14.159.938 15 1.778 15 2.813v9.376c0 1.034-.84 1.874-1.875 1.874H1.875A1.877 1.877 0 0 1 0 12.188V2.812Zm1.875 0v1.874H3.75V2.813H1.875Zm11.25 0h-7.5v1.874h7.5V2.813Zm-11.25 3.75v1.875H3.75V6.562H1.875Zm11.25 0h-7.5v1.875h7.5V6.562Zm-11.25 3.75v1.874H3.75v-1.874H1.875Zm11.25 0h-7.5v1.874h7.5v-1.874Z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"#fff","d":"M0 0h15v15H0z"})))]);
}

UnloggedIcon.defaultProps = {"fill":"currentColor","viewBox":"0 0 15 15"};

module.exports = UnloggedIcon;

UnloggedIcon.default = UnloggedIcon;
